var map = {
	"./arrow.svg": 2,
	"./business.svg": 24,
	"./close.svg": 7,
	"./fb.svg": 5,
	"./in.svg": 4,
	"./poligon-big.svg": 8,
	"./poligon.svg": 3,
	"./privacy.svg": 25,
	"./security.svg": 26,
	"./software.svg": 27,
	"./tw.svg": 11,
	"./vpn.svg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;